import { TIER_PART_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { GroupRow, IPRow, OURow, ServerRow } from '../../../../../../../sharedComponents/scope/ResourcesRows';
import { SCOPE_SHOW_SERVICES } from '../TierConsts';
import { ButtonLink } from '@silverfort/sf-components';

const ResourcesList = ({ resources, scope, selected = {}, onSelect, onDelete, onClearAll, disabled }) => {
    const resourcesRows = resources.map((resource) => {
        switch (resource.type) {
            case TIER_PART_TYPES.SERVERS: {
                return (
                    <ServerRow
                        key={`server_${resource.id}`}
                        guid={resource.id}
                        name={resource.name}
                        domainName={resource.domainName}
                        services={resource.services}
                        protocols={resource.protocols ?? []}
                        selected={resource.type === selected.type && resource.id === selected.id}
                        onClick={onSelect ? () => onSelect(resource) : undefined}
                        onDelete={onDelete ? () => onDelete(resource) : undefined}
                        showProtocols={SCOPE_SHOW_SERVICES[scope]}
                        disabled={disabled}
                    />
                );
            }
            case TIER_PART_TYPES.GROUPS: {
                return (
                    <GroupRow
                        key={`group_${resource.id}`}
                        guid={resource.id}
                        name={resource.name}
                        domainName={resource.domainName}
                        services={resource.services}
                        protocols={resource.protocols ?? []}
                        selected={resource.type === selected.type && resource.id === selected.id}
                        onClick={onSelect ? () => onSelect(resource) : undefined}
                        onDelete={onDelete ? () => onDelete(resource) : undefined}
                        showProtocols={SCOPE_SHOW_SERVICES[scope]}
                        disabled={disabled}
                    />
                );
            }
            case TIER_PART_TYPES.OUS: {
                return (
                    <OURow
                        key={`ou_${resource.id}`}
                        guid={resource.id}
                        name={resource.name}
                        domainName={resource.domainName}
                        services={resource.services}
                        protocols={resource.protocols ?? []}
                        selected={resource.type === selected.type && resource.id === selected.id}
                        onClick={onSelect ? () => onSelect(resource) : undefined}
                        onDelete={onDelete ? () => onDelete(resource) : undefined}
                        showProtocols={SCOPE_SHOW_SERVICES[scope]}
                        disabled={disabled}
                    />
                );
            }
            case TIER_PART_TYPES.IPS: {
                return (
                    <IPRow
                        key={`ip_${resource.id}`}
                        ip={resource.id}
                        services={resource.services}
                        protocols={resource.protocols ?? []}
                        selected={resource.type === selected.type && resource.id === selected.id}
                        onClick={onSelect ? () => onSelect(resource) : undefined}
                        onDelete={onDelete ? () => onDelete(resource) : undefined}
                        showProtocols={SCOPE_SHOW_SERVICES[scope]}
                        disabled={disabled}
                    />
                );
            }
            default: {
                return {};
            }
        }
    });

    return (
        <div className="w-full h-full flex flex-col">
            <div className="flex justify-between px-4 h-10 items-center border-b border-sf-gray-100">
                <div className="text-sf font-medium">Resources {`(${resources.length})`}</div>
                <ButtonLink
                    onClick={onClearAll ? onClearAll : undefined}
                    underline={true}
                    text={'Clear All'}
                    className="text-xs font-normal text-sf-gray-400"
                    disabled={disabled || !onClearAll}
                />
            </div>
            <div className="py-4 px-2 flex-1 w-full h-full overflow-y-auto no-scrollbar">{resourcesRows}</div>
        </div>
    );
};

export default ResourcesList;
